import { useMemo } from 'react';
import { gql, useQuery } from 'urql';
import { SendContentType } from './useSendMessages';

export const GET_SENDING_MESSAGE_COUNT_QUERY = gql`
  query GetSendingMessageCount($input: SendingMessageCountInputObject!) {
    getSendingMessageCount(input: $input) {
      emailWillBeSent
      smsWillBeSent
      vkWillBeSent
      ticketIds
    }
  }
`;

export interface GetSendingMessageCountInput {
  eventId: number;
  contentType: SendContentType.Invite | SendContentType.Ticket;
  ticketIds: number[];
}

interface GetSendingMessageCountResponse {
  getSendingMessageCount: {
    emailWillBeSent: number;
    smsWillBeSent: number;
    vkWillBeSent: number;
    ticketIds: number[];
  };
}

export const useGetSendingMessageCount = (input: GetSendingMessageCountInput | null) => {
  const variables = useMemo(() => (input ? { input } : undefined), [input]);

  const [{ data, error, fetching }] = useQuery<GetSendingMessageCountResponse>({
    query: GET_SENDING_MESSAGE_COUNT_QUERY,
    variables,
    pause: !variables,
    requestPolicy: 'network-only',
  });

  return {
    sendingMessageCount: data?.getSendingMessageCount ?? null,
    error,
    fetching,
  };
};
